/*
 * Copyright (c) Akveo 2019. All Rights Reserved.
 * Licensed under the Single Application / Multi Application License.
 * See LICENSE_SINGLE_APP / LICENSE_MULTI_APP in the 'docs' folder for license information on type of purchased license.
 */

import { Component, Injectable, Input } from '@angular/core';
import { NbDialogRef, NbDialogService, NbGlobalLogicalPosition, NbToastrService } from '@nebular/theme';

@Injectable()
export class AlertService {

  constructor(
    private toast: NbToastrService,
    private dialog: NbDialogService
  ) {}

  savingAlert(message = "Saving..."){
    return this.toast.info(null, message,
      {
        icon: 'clock-outline',
        limit: 1,
        position: NbGlobalLogicalPosition.TOP_END,
        duration: 0,
      });
  }

  successAlert(message = "Saved successfully"){
    return this.toast.success(null, message,
      {
        icon: 'checkmark-circle-outline',
        limit: 3,
        position: NbGlobalLogicalPosition.TOP_END,
      });
  }
  
  errorAlert(message = "Failed to save", title=null){
    return this.toast.danger(title, message,
      {
        icon: 'alert-circle-outline',
        limit: 5,
        position: NbGlobalLogicalPosition.TOP_END,
      });
  }

  warningAlert(message, title=null){
    return this.toast.warning(title, message,
      {
        icon: 'question-mark-circle-outline',
        limit: 5,
        position: NbGlobalLogicalPosition.TOP_END,
      });
  }

  confirmationDialog(title){
    return new Promise ((resolve, reject)=>{
  
      this.dialog.open(ConfirmationDialog, { context: {title: title} })
      .onClose.subscribe(res => {
        return resolve(res)
      });
    })

  }

}

@Component({
  selector: 'confirmation-dialog',
  template: `
      <nb-card>
        <nb-card-header>{{ title }}</nb-card-header>
        <nb-card-footer>
          <button nbButton (click)="close(false)" class="mr-5">Cancel</button>
          <button nbButton status="danger" (click)="close(true)" >Yes</button>
        </nb-card-footer>
      </nb-card>
  `,
})
export class ConfirmationDialog {

  @Input() title: string;
  constructor(protected dialogRef: NbDialogRef<any>) {
  }
  
  close(res) {
    this.dialogRef.close(res);
  }
}